// 这是一个防抖指令。 这是一个严格的标准的防抖
// const debounce = {
//   inserted() {},
//   bind(el, binding) {
//     let timer;
//     el.__debounceFun = function() {
//       const _this = this;
//       const arg = arguments;
//       if (timer) {
//         clearTimeout(timer);
//       }
//       timer = setTimeout(() => {
//         binding.value.apply(_this, arg);
//       }, 2000);
//     };
//     el.addEventListener("click", el.__debounceFun);
//   },
//   unbind(el) {
//     el.removeEventListener("click", el.__debounceFun, true);
//   },
// };
// 这是一个立即执行的防抖

const debounce = {
  bind(el, binding) {
    let timeout;
    el.__debounceFun = function() {
      const context = this;
      const args = arguments;
      if (timeout) clearTimeout(timeout); // 这是关键
      const callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, 1500);
      callNow && binding.value.apply(context, args);
    };
    el.addEventListener('click', el.__debounceFun);
  },
  unbind(el) {
    el.removeEventListener('click', el.__debounceFun, true);
  },
};
export default debounce;
